import { DecimalPipe, PercentPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { SharedModule as SigvSharedModule } from 'sigv-library';
import { AddressInputComponent } from './components/address-input/address-input.component';
import { DateFieldErrorComponent } from './components/date-field-error/date-field-error.component';
import { DescriptionErrorDialogComponent } from './components/description-error-dialog/description-error-dialog.component';
import { EKYCComponent } from './components/ekyc/ekyc.component';
import { FieldEnterErrorComponent } from './components/field-enter-error/field-enter-error.component';
import { FieldErrorComponent } from './components/field-error/field-error.component';
import { FormFieldErrorDialogComponent } from './components/form-field-error-dialog/form-field-error-dialog.component';
import { InnerTableComponent } from './components/inner-table/inner-table.component';
import { MiniPaginatorComponent } from './components/mini-paginator/mini-paginator.component';
import { CheckIdDirective } from './directives/check-id.directive';
import { EqualToDirective } from './directives/equal-to.directive';
import { PasswordComplexityDirective } from './directives/password-complexity.directive';
import { SmallTableRowModifyDirective } from './directives/small-table-row-modify.directive';
import { ArrayFilterPipe } from './pipes/array-filter.pipe';
import { CalculateTotalPipe } from './pipes/calculate-total.pipe';
import { CalendarErrorMappingPipe } from './pipes/calendar-error-mapping.pipe';
import { CaseStatusPipe } from './pipes/case-status.pipe';
import { ChargeToPipe } from './pipes/charge-to.pipe';
import { DealerDropdownPipe } from './pipes/dealer-dropdown.pipe';
import { DropdownPipe } from './pipes/dropdown.pipe';
import { ExpenseTypePipe } from './pipes/expense-type.pipe';
import { FieldSettingPipe } from './pipes/field-setting.pipe';
import { FractionDigitsPipe } from './pipes/fraction-digits.pipe';
import { IconSourcePipe } from './pipes/icon-source.pipe';
import { InsuranceTypePipe } from './pipes/insurance-type.pipe';
import { NewsDescriptionPipe } from './pipes/news-description.pipe';
import { ProductFeePaymentPipe } from './pipes/product-fee-payment.pipe';
import { ToDatePipe } from './pipes/to-date.pipe';
import { ViewAddressPipe } from './pipes/view-address.pipe';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DownloadPasswordDialogComponent } from './components/download-password-dialog/download-password-dialog.component';
import { CameraCaptureDialogComponent } from './components/camera-capture-dialog/camera-capture-dialog.component';
import { ImageCropDialogComponent } from './components/image-crop-dialog/image-crop-dialog.component';
import { MobileCellComponent } from './components/mobile-cell/mobile-cell.component';
import { PdfCropDialogComponent } from './components/pdf-crop-dialog/pdf-crop-dialog.component';
import { MobileTotalRecordsComponent } from './components/mobile-total-records/mobile-total-records.component';
import { OCRComponent } from './components/ocr/ocr.component';
import { QueryCustomerDialogComponent } from './components/query-customer-dialog/query-customer-dialog.component';
import { InputTrimDirective } from './directives/input-trim.directive';
import { CancelReasonPipe } from './pipes/cancel-reason.pipe';
import { NotificationContentPipe } from './pipes/notification-content.pipe';
import { NotificationTitlePipe } from './pipes/notification-title.pipe';
import { WorkFlowStagePipe } from './pipes/work-flow-stage.pipe';
import { PrimengModule } from './primeng.module';

@NgModule({
  declarations: [
    DescriptionErrorDialogComponent,
    FieldErrorComponent,
    FieldEnterErrorComponent,
    FormFieldErrorDialogComponent,
    CheckIdDirective,
    EqualToDirective,
    PasswordComplexityDirective,
    SmallTableRowModifyDirective,
    ProductFeePaymentPipe,
    ChargeToPipe,
    AddressInputComponent,
    DateFieldErrorComponent,
    CalculateTotalPipe,
    InsuranceTypePipe,
    ToDatePipe,
    FieldSettingPipe,
    DropdownPipe,
    CaseStatusPipe,
    CancelReasonPipe,
    WorkFlowStagePipe,
    NewsDescriptionPipe,
    InnerTableComponent,
    ExpenseTypePipe,
    ViewAddressPipe,
    NotificationTitlePipe,
    NotificationContentPipe,
    CalendarErrorMappingPipe,
    DealerDropdownPipe,
    FractionDigitsPipe,
    MiniPaginatorComponent,
    ArrayFilterPipe,
    EKYCComponent,
    IconSourcePipe,
    InputTrimDirective,
    MobileTotalRecordsComponent,
    QueryCustomerDialogComponent,
    MobileCellComponent,
    OCRComponent,
    DownloadPasswordDialogComponent,
    ImageCropDialogComponent,
    PdfCropDialogComponent,
    CameraCaptureDialogComponent,
  ],
  imports: [
    SigvSharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    PdfViewerModule,
    ImageCropperModule,
  ],
  exports: [
    // provider import shared module can use other module
    TranslateModule,
    SigvSharedModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    // shared component, directive, pipes
    DescriptionErrorDialogComponent,
    FieldErrorComponent,
    FieldEnterErrorComponent,
    FormFieldErrorDialogComponent,
    CheckIdDirective,
    EqualToDirective,
    PasswordComplexityDirective,
    SmallTableRowModifyDirective,
    ProductFeePaymentPipe,
    ChargeToPipe,
    AddressInputComponent,
    CalculateTotalPipe,
    InsuranceTypePipe,
    ToDatePipe,
    FieldSettingPipe,
    DropdownPipe,
    CaseStatusPipe,
    CancelReasonPipe,
    WorkFlowStagePipe,
    NewsDescriptionPipe,
    InnerTableComponent,
    ExpenseTypePipe,
    ViewAddressPipe,
    DateFieldErrorComponent,
    DealerDropdownPipe,
    FractionDigitsPipe,
    MiniPaginatorComponent,
    ArrayFilterPipe,
    EKYCComponent,
    IconSourcePipe,
    NotificationTitlePipe,
    NotificationContentPipe,
    InputTrimDirective,
    MobileTotalRecordsComponent,
    QueryCustomerDialogComponent,
    MobileCellComponent,
    OCRComponent,
    DownloadPasswordDialogComponent,
    ImageCropDialogComponent,
    PdfCropDialogComponent,
    CameraCaptureDialogComponent,
  ],
  providers: [DecimalPipe, TranslatePipe, PercentPipe],
})
export class SharedModule {}
